import { render, staticRenderFns } from "./AcademyFile.vue?vue&type=template&id=e599b3b6&scoped=true&"
import script from "./AcademyFile.vue?vue&type=script&lang=js&"
export * from "./AcademyFile.vue?vue&type=script&lang=js&"
import style0 from "./AcademyFile.vue?vue&type=style&index=0&id=e599b3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e599b3b6",
  null
  
)

export default component.exports